import { i18n } from '@fs/zion-locale'

type LocaleConfig = {
  headers: { 'Accept-Language': string; 'Content-Language': string; 'Content-Type': string }
  data: Record<string, never>
}

/** Axios config for endpoints that only require a JSON content type. */
export const JSON_CONFIG = { headers: { 'Content-Type': 'application/json' }, data: {} as Record<string, never> }

/**
 * Returns axios config with locale headers derived at call time.
 * Using a function (rather than a module-level constant) ensures the current
 * language is read on each request instead of being frozen at module load.
 */
export function getLocaleConfig(): LocaleConfig {
  const lang = i18n.language
  return {
    ...JSON_CONFIG,
    headers: { ...JSON_CONFIG.headers, 'Accept-Language': lang, 'Content-Language': lang },
  }
}
